// MaintenancePage.tsx
import React from "react";
import { styled, Container, Typography, Grid, CssBaseline } from "@mui/material";

import CnbDesktop from "../icons/cnbDesktop";

export const StyledContainer = styled(Container)({
  height: "100vh",
  padding: "150px 20px 250px 20px",
  width: "100%",
  boxShadow: "none",
  background: "#002035",
  color: "white",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const StyledGrid = styled(Grid)({
  textAlign: "center",
});

export const StyledTypography = styled(Typography)({
  fontSize: "24px",
});
export const StyledHeader = styled(Typography)({
  fontSize: "34px",
  fontWeight: 900,
});

export const MaintenanceImage = styled("img")(({ theme }) => ({
  marginBottom: "30px",
  maxWidth: "100%",
  [theme.breakpoints.down("sm")]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

const verificationMessageA =
  "Welcome to Caleb & Brown’s Portal. We are running a system maintenance at the moment.";
const verificationMessageB =
  "We are currently working on this page. If you require urgent assistance, please contact us at support@calebandbrown.com";

export default function MaintenancePage() {
  return (
    <StyledContainer>
      <CssBaseline />
      <StyledGrid container>
        <StyledGrid item xs={12}>
          <CnbDesktop height="80px" />
        </StyledGrid>

        <StyledGrid item xs={12} mt={12}>
          <MaintenanceImage src="/maintenancePage.png" />
          <StyledHeader>We will be back soon.</StyledHeader>
          <StyledTypography>{verificationMessageA}</StyledTypography>
          <StyledTypography>{verificationMessageB}</StyledTypography>
        </StyledGrid>
      </StyledGrid>
    </StyledContainer>
  );
}
